import { createContext, useContext } from 'react'

export interface ModalContextValue {
  onClose: () => void
  variant: 'default' | 'danger'
}

export const ModalContext = createContext<ModalContextValue | null>(null)

export const useModalContext = () => {
  const ctx = useContext(ModalContext)
  if (!ctx) throw new Error('Modal.* must be used within <Modal>')
  return ctx
}
